(function() {
    'use strict';

    angular
        .module('app.grupos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/grupos',
                config: {
                    templateUrl: 'app/grupos/grupos.html',
                    controller: 'Grupos',
                    controllerAs: 'vm',
                    title: 'Grupos',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            },
            {
                url: '/editar-grupo/:id?',
                config: {
                    templateUrl: 'app/grupos/editarGrupos.html',
                    controller: 'EditarGrupo',
                    controllerAs: 'vm',
                    title: 'EditarGrupos',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            }
        ];
    }
})();
